<template>
  <Card style="width: 100%; margin-bottom: 2em">
    <template #title>
      <h4 style="display: inline-block;">{{ $t("ingredients") }}</h4>
      <Dropdown
        v-model="selected"
        :options="options"
        optionLabel="name"
        placeholder="Select number of people"
        style="float:right;"
      />
    </template>
    <template #content>
      <div class="two-columns">
        <div
          v-for="(ingredient, index) in ingredients"
          :key="ingredient.id"
          class="mb-2"
        >
          <Checkbox
            v-model="ingredientsChecked[index]"
            :id="ingredient.id"
            :binary="true"
          />
          <label :for="ingredient.id" class="ml-4">{{
            $t(ingredient.ingredient.data.attributes.key) +
              " " +
              (ingredient.value != 0 ? ingredient.value : "") +
              " " +
              (ingredient.unit.data != null
                ? $t(ingredient.unit.data.attributes.key)
                : "")
          }}</label>
        </div>
      </div>
    </template>
    <template #footer>
      <div style="text-align:right;">
        <Button
          :label="$t('select_all')"
          class="ingredients-button"
          @click="selectAll"
        />
        <Button
          icon="pi pi-plus"
          :label="$t('add_shopping_list')"
          class="ingredients-button"
          style="margin-left: .5em"
          @click="addToShoppingList()"
        />
      </div>
    </template>
  </Card>
</template>

<script>
import ShoppingListService from "../../service/ShoppingListService.js";
export default {
  data() {
    return {
      selected: null,
      options: null,
      ingredientsChecked: [],
      shoppingListToSend: {
        shopping_list: [],
      },
      shoppingListService: null,
      shopping_list: [],
    };
  },
  computed: {
    ingredients: function() {
      return this.$store.getters["recipes/getRecipe"].ingredients;
    },
    singleRecipe: function() {
      return this.$store.getters["recipes/getRecipe"];
    },
    locale: function() {
      return this.$store.getters["preferences/locale"];
    },
    languages: function() {
      return this.$store.getters["labels/languages"];
    },
    access_token: function() {
      return this.$store.getters["userdata/getAccessToken"];
    },
    user_id: function() {
      return this.$store.getters["profile/id"];
    },
  },
  created() {
    this.shoppingListService = new ShoppingListService();
  },
  async mounted() {
    this.shopping_list = await this.shoppingListService.getShoppingList(
      this.access_token,
      this.user_id
    );
    this.ingredientsChecked = Array(this.ingredients.length).fill(false);
    this.importUnitTranslations();
  },
  methods: {
    async addToShoppingList() {
      this.shopping_list.forEach((item) => {
        let unit = item.unit ? item.unit.id : null;
        this.shoppingListToSend.shopping_list.push({
          value: item.value,
          ingredient: item.ingredient.id,
          unit: unit,
        });
      });
      this.ingredients.forEach((item, index) => {
        let unit = item.unit.data ? item.unit.data.id : null;
        let value = item.value;
        if (this.ingredientsChecked[index]) {
          let elem = this.shoppingListToSend.shopping_list.findIndex(
            (e) => e.ingredient === item.ingredient.data.id
          );
          if (elem > -1) {
            this.shoppingListToSend.shopping_list[elem].value += value;
          } else {
            this.shoppingListToSend.shopping_list.push({
              value: value,
              ingredient: item.ingredient.data.id,
              unit: unit,
            });
          }
        }
      });
      await this.shoppingListService.putShoppingList(
        this.access_token,
        this.user_id,
        this.shoppingListToSend
      );
      this.ingredientsChecked = Array(this.ingredients.length).fill(false);
    },
    selectAll() {
      this.ingredientsChecked = this.ingredientsChecked.map(() => true);
    },
    async importUnitTranslations() {
      let translations = new Array(this.languages.length);
      this.languages.forEach((elem, index) => {
        translations[index] = {};
        translations[index].locale = elem.code;
        translations[index].labels = {};
      });
      this.ingredients.forEach((elem) => {
        if (elem.unit.data) {
          var path = elem.unit.data.attributes.key;
          elem.unit.data.attributes.labels.data.forEach((label) => {
            let index = translations.findIndex(
              (x) => x.locale === label.attributes.locale
            );
            var value = label.attributes.value;
            var obj = translations[index].labels;
            var parts = path.split("."),
              part;
            var last = parts.pop();
            // eslint-disable-next-line no-cond-assign
            while ((part = parts.shift())) {
              if (typeof obj[part] != "object") obj[part] = {};
              obj = obj[part]; // update "pointer"
            }
            obj[last] = value;
          });
        }
      });
      translations.forEach((elem) => {
        let old = this.$i18n.getLocaleMessage(elem.locale);
        this.$i18n.setLocaleMessage(elem.locale, {
          ...old,
          ...elem.labels,
        });
      });
      this.$i18n;
    },
  },
};
</script>

<style></style>
